<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i v-if="id" class="right angle icon divider"></i>
    <a v-if="id" class="active" v-on:click="goTo('/corporations')">Corporaciones</a>
    <i class="right angle icon divider"></i>
    <a class="section" v-on:click="goTo('/corporations/users')">Usuarios</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Editar Usuario</a>
  </div>
  <h1 class="ui header"><i class="icon user"></i>
    <div class="content">Editar Usuario</div>
  </h1>
  <button v-if="id" class="ui basic button rightButton" v-on:click="goTo('/corporations/'+id+'/users')">
    <i class="long arrow alternate left icon"></i>Atras
  </button>
  <button v-if="!id" class="ui basic button rightButton" v-on:click="goTo('/corporations/users')">
    <i class="long arrow alternate left icon"></i>Atras
  </button>
  <div v-if="!selectedUser" class="ui active centered inline loader"></div>
  <div v-if="selectedUser" class="ui stackable two column divided grid container">
    <div class="row">
      <div class="column">
        <form class="ui form" @submit.prevent="editCorporationUser">
          <h4 class="ui dividing header">Información del usuario</h4>
          <div class="inline field">
            <sui-checkbox label="Activo" toggle v-model="selectedUser.active" />
          </div>
          <div class="field">
            <label>Nombre</label>
            <input type="text" v-model="selectedUser.name" placeholder="Nombre" required>
          </div>
          <div class="field">
            <label>Apellidos</label>
            <input type="text" v-model="selectedUser.surname" placeholder="Apellidos" required>
          </div>
          <div class="field">
            <label>Teléfono</label>
            <input type="text" v-model="selectedUser.phone_number" placeholder="Teléfono">
          </div>
          <div class="field">
            <label>Email</label>
            <input type="text" v-model="selectedUser.email" placeholder="Email">
          </div>
          <div class="two fields">
            <div class="field">
              <label>Creado</label>
              <input type="text" v-model="selectedUser.created" readonly>
            </div>
            <div class="field">
              <label>Modificado</label>
              <input type="text" v-model="selectedUser.modified" readonly>
            </div>
          </div>
          <button id="save" class="ui button fluid" type="submit">Guardar</button>
        </form>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'editCorporationsUser',
  props: ['id','userId'],
  data() {
    return {
      selectedUser: null
    }
  },
  created(){
    let role = JSON.parse(localStorage.admin).role
    if (role === 'master' || role === 'admin' || role ==='corporate' || role ==='hmyCorporate') {
      this.getCorporationUser()
    } else {
      this.$router.replace('/parcels_v2')
    }
  },
  methods: {
    getCorporationUser() {
      hapiickApi().post('/v1/corporations/users/get-corporation-user', {
        admin_id: JSON.parse(localStorage.admin).id,
        corp_id: this.id,
        user_id: this.userId
      })
      .then(request => this.updateEditUser(request))
      .catch(() => console.log('error getting user'))
    },
    editCorporationUser() {
      let x = document.getElementById("save");
      x.classList.add("loading");
      x.disabled = true;

      hapiickApi().post('/v2/corporations/users/edit', {
        admin_id: JSON.parse(localStorage.admin).id,
        corp_id: this.id,
        userData: this.selectedUser,
      })
      .then(request => this.userSaved(request))
    },
    goTo(where) {
      this.$router.push(where)
    },
    updateEditUser(req) {
      let user = JSON.parse(JSON.stringify(req.data.data.user))
      this.selectedUser = user.CorporationsUser
    },
    userSaved(req) {
      let msg = '';
      if (req.data.status !== 'OK') {
        if (req.data.status === "KO") {
          msg = req.data.message;
        } else {
          msg = 'No se han podido guardar los datos';
        }
        this.$swal({
          type: 'error',
          title: 'Error',
          text: msg
        })

        let x = document.getElementById("save");
        x.classList.remove("loading");
        x.disabled = false;
      } else {
        this.$swal({
          type: 'success',
          title: 'Los datos se han guardado correctamente',
          showConfirmButton: false,
          timer: 2500
        })
        this.selectedUser = null
        if(this.id !== undefined){
          this.goTo('/corporations/'+this.id+'/users')
        }else{
          this.goTo('/corporations/users')
        }
      }
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Corporations/editCorporationsUser.vue